import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import MfaChallenge from '../components/Auth/MfaChallenge/MfaChallenge'

const MfaChallengePage = () => {
  const [searchParams] = useSearchParams()
  const [mfaToken, setMfaToken] = useState(null)

  useEffect(() => {
    // Check URL query param first (OAuth flow)
    const urlToken = searchParams.get('mfa_token')
    if (urlToken) {
      sessionStorage.setItem('mfa_token', urlToken)
      // Clean URL to remove sensitive token
      window.history.replaceState({}, '', '/mfa-challenge')
      setMfaToken(urlToken)
      return
    }

    // Fall back to sessionStorage (password login flow)
    const storedToken = sessionStorage.getItem('mfa_token')
    if (storedToken) {
      setMfaToken(storedToken)
    }
  }, [searchParams])

  return <MfaChallenge mfaToken={mfaToken} />
}

export default MfaChallengePage
